import React from 'react'
import Service_1 from '../../../assets/images/home_page_2/services/05.png'
import Service_2 from '../../../assets/images/home_page_2/services/06.png'
import Service_3 from '../../../assets/images/home_page_2/services/07.png'
import Service_4 from '../../../assets/images/home_page_2/services/08.png'

const Services = () => {
    return (
        <>
            <section id="services-two" className="services-two-main-block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="service-two-block">
                                <div className="services-two-img">
                                    <img
                                        src={Service_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-two-dtls">
                                    <h4 className="services-two-heading">Free Shipping</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="service-two-block">
                                <div className="services-two-img">
                                    <img
                                        src={Service_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-two-dtls">
                                    <h4 className="services-two-heading">Amazing Deals</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="service-two-block">
                                <div className="services-two-img">
                                    <img
                                        src={Service_3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-two-dtls">
                                    <h4 className="services-two-heading">Expert Teams</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="service-two-block">
                                <div className="services-two-img">
                                    <img
                                        src={Service_4}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-two-dtls">
                                    <h4 className="services-two-heading">Support Center</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Services
